import { filter } from 'rxjs/operators';

export function isNotNullOrUndefined<T>(input: null | undefined | T): input is T {
    return input != null;
}

export const filterNullOrUndefined = () => filter(isNotNullOrUndefined);
